import React from 'react';
import services from './services';

class ErrorBoundary extends React.Component {
  state = { 
    hasError: false, 
    error : null,
    errorInfo:null
  };

  // static getDerivedStateFromError(error) {
  //   console.log("sdwecewcwecewcewcew",error)
  //   return { hasError: true };
  // }

  componentDidCatch(error, info) {
    this.setState({
      error,
      errorInfo:info
    },()=>this.createErrorLog())
    
    console.log("sdwecewcwecewcewcew",info.componentStack)
    // logComponentStackToMyService(info.componentStack);
  }

  createErrorLog = async () => {
    let errorLog = {
      pageUrl:window.location.href,
      errors:this.state.errorInfo.componentStack
    }

    let data = {
      error : JSON.stringify(errorLog)
    }

    let res = await services.apiCall.requestApi('/ErrorLog/Create',data,'post')
    if(res && window.location.href.includes('ivdp.ambisig.com')) window.location.reload()
  }

  render() {
    if (this.state.errorInfo && window.location.href.includes('ivdp.ambisig.com')) {
      return (
        <div style={{padding:"30px"}}>
          <h1>Alguma coisa deu errado. Por favor tente outr avez.</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      )
    }

    return this.props.children; 
  }
}
export default ErrorBoundary;